// Module Vuex pour l'attribution
const state = { 
  items: [], 
  loading: false, 
  error: null,
  // État du modal
  isModalOpen: false,
  modalParams: {
    lots: [],
    teamId: null,
    managerId: null
  },
  // Timestamp pour déclencher le rafraîchissement
  lastAttributionUpdate: null
}

const mutations = {
  SET_ITEMS(state, items) { 
    state.items = items 
  },
  SET_LOADING(state, loading) { 
    state.loading = loading 
  },
  SET_ERROR(state, error) { 
    state.error = error 
  },
  OPEN_MODAL(state, params) {
    state.isModalOpen = true
    state.modalParams = {
      lots: params.lots || [],
      teamId: params.teamId || null,
      managerId: params.managerId || null
    }
  },
  CLOSE_MODAL(state) {
    state.isModalOpen = false
    state.modalParams = {
      lots: [],
      teamId: null,
      managerId: null
    }
  },
  TRIGGER_REFRESH(state) {
    state.lastAttributionUpdate = Date.now()
  }
}

const actions = {
  setItems({ commit }, items) { 
    commit('SET_ITEMS', items) 
  },
  setLoading({ commit }, loading) { 
    commit('SET_LOADING', loading) 
  },
  setError({ commit }, error) { 
    commit('SET_ERROR', error) 
  },
  openModal({ commit }, params) {
    commit('OPEN_MODAL', params)
  },
  closeModal({ commit }) {
    commit('CLOSE_MODAL')
  },
  triggerRefresh({ commit }) {
    commit('TRIGGER_REFRESH')
  }
}

const getters = {
  items: state => state.items,
  loading: state => state.loading,
  error: state => state.error,
  isModalOpen: state => state.isModalOpen,
  modalParams: state => state.modalParams,
  lastAttributionUpdate: state => state.lastAttributionUpdate
}

export default { 
  namespaced: true, 
  state, 
  mutations, 
  actions, 
  getters 
}
